import { lazy } from "react";

export { HOME_PATH } from "./home-path";
export const Home = lazy(() => import(/* webpackChunkName: "home" */ "./home"));
